import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-10 mt-10">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-6">
        <div>
          <h3 className="font-bold mb-3">Shopatrave</h3>
          <p className="text-gray-400 text-sm">Wholesale distributor — Best products at best prices.</p>
        </div>
        <div>
          <h3 className="font-bold mb-3">Company</h3>
          <ul className="space-y-2">
            <li><Link to="/about" className="text-gray-300 hover:text-white">About</Link></li>
            <li><Link to="/contact" className="text-gray-300 hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-bold mb-3">Legal</h3>
          <ul className="space-y-2">
            <li><Link to="/privacy-policy" className="text-gray-300 hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-gray-300 hover:text-white">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>
      <p className="text-center mt-6 text-gray-500 text-sm">© 2025 Shopatrave. All Rights Reserved.</p>
    </footer>
  );
}
